<template>
  <file-selector
    :id="inputId"
    v-model="file"
    class="dropzone"
    background="transparent"
    border-color="#cde0ff"
    :accept="['.pdf']"
    @invalid="$emit('invalid')"
  >
    <template #label>
      <div class="pa-4">
        <v-row no-gutters justify="center" class="pb-4">
          <v-icon large>picture_as_pdf</v-icon>
        </v-row>
        <v-row
          no-gutters
          justify="center"
          class="subtitle-2 font-weight-bold grey--text text--darken-3 pb-3"
        >
          Drop full-text PDF file here
        </v-row>
        <v-row no-gutters justify="center" class="grey--text pb-3">
          or
        </v-row>
        <v-row no-gutters justify="center" class="pb-3">
          <action-button color="primary" @click="browseFiles">
            Browse Files
          </action-button>
        </v-row>
      </div>
    </template>
  </file-selector>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import FileSelector from '@/components/Common/FileSelector';
import { v4 as uuid } from 'uuid';

export default {
  name: 'FullTextPdfDropzone',
  components: { ActionButton, FileSelector },
  props: {
    value: {
      type: File,
      default: null,
    },
  },
  data: () => ({ inputId: `full-text-pdf-dropzone-${uuid()}` }),
  computed: {
    file: {
      get: function () {
        return this.value;
      },
      set: function (file) {
        this.$emit('input', file);
      },
    },
    inputElement() {
      return document.getElementById(this.inputId);
    },
  },
  methods: {
    browseFiles() {
      this.inputElement.click();
    },
  },
};
</script>

<style lang="scss" scoped>
.dropzone {
  max-width: 340px;
}
</style>
